function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { PureComponent } from "react";
import classNames from "classnames";
import Tracker from "../utils/piwik";
import { getUnreadCount } from "../utils/SocialGroupsUtils";
import { getNoteCount } from "../utils/SocialNotesUtils";
import { isEqual } from "lodash";
import { injectIntl } from "react-intl";
import ProgressDisplay from "./ProgressDisplay";
import PageDisplay from "./PageDisplay";
import eventBus from "../utils/eventBus";
import Icon from "./Icon";
import UISwitch from "./ui/UISwitch";
var canKeyInput = function() {
    return !document.querySelector(".DraftEditor-root");
};
var AppFooter = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(AppFooter, PureComponent);
    var _super = _createSuper(AppFooter);
    function AppFooter(props) {
        _classCallCheck(this, AppFooter);
        var _this;
        _this = _super.call(this, props);
        _this._onStoryModeToggle = function() {
            var _this_props = _this.props, storyMode = _this_props.storyMode, setStoryMode = _this_props.setStoryMode;
            setStoryMode(!storyMode);
        };
        _this._onActivityCenterToggle = function(evnt) {
            evnt.preventDefault();
            var _this_props = _this.props, uiVisibilityState = _this_props.uiVisibilityState, setUIVisibilityState = _this_props.setUIVisibilityState, activityDisabled = _this_props.activityDisabled, notify = _this_props.notify;
            if (activityDisabled) {
                notify("action_not_allowed_while_exam");
            } else {
                setUIVisibilityState({
                    activityCenter: !uiVisibilityState.activityCenter,
                    notes: false,
                    bonusMaterial: false,
                    quickNav: false
                });
            }
        };
        _this._onNotesToggle = function(evnt) {
            evnt.preventDefault();
            var _this_props = _this.props, uiVisibilityState = _this_props.uiVisibilityState, setUIVisibilityState = _this_props.setUIVisibilityState, notesDisabled = _this_props.notesDisabled, notify = _this_props.notify;
            if (notesDisabled) {
                notify("action_not_allowed_while_exam");
            } else {
                setUIVisibilityState({
                    activityCenter: false,
                    notes: !uiVisibilityState.notes,
                    bonusMaterial: false,
                    quickNav: false
                });
            }
        };
        _this._onBonusMaterialToggle = function(evnt) {
            evnt.preventDefault();
            var _this_props = _this.props, uiVisibilityState = _this_props.uiVisibilityState, setUIVisibilityState = _this_props.setUIVisibilityState, bonusDisabled = _this_props.bonusDisabled, notify = _this_props.notify;
            if (bonusDisabled) {
                notify("action_not_allowed_while_exam");
            } else {
                setUIVisibilityState({
                    activityCenter: false,
                    notes: false,
                    bonusMaterial: !uiVisibilityState.bonusMaterial,
                    quickNav: false
                });
            }
        };
        _this._onFavouritesToggle = function(evnt) {
            evnt.preventDefault();
            var _this_props = _this.props, uiVisibilityState = _this_props.uiVisibilityState, setUIVisibilityState = _this_props.setUIVisibilityState, notify = _this_props.notify, quickNavHideMenu = _this_props.quickNavHideMenu, navDisabled = _this_props.navDisabled;
            if (navDisabled) {
                notify("action_not_allowed_while_exam");
            } else {
                setUIVisibilityState({
                    quickFavourites: !uiVisibilityState.quickFavourites,
                    activityCenter: quickNavHideMenu && !uiVisibilityState.quickFavourites ? false : uiVisibilityState.activityCenter,
                    bonusMaterial: quickNavHideMenu && !uiVisibilityState.quickFavourites ? false : uiVisibilityState.bonusMaterial,
                    menu: quickNavHideMenu && !uiVisibilityState.quickFavourites ? false : uiVisibilityState.menu,
                    navigation: quickNavHideMenu && !uiVisibilityState.quickFavourites ? false : uiVisibilityState.navigation,
                    notes: quickNavHideMenu && !uiVisibilityState.quickFavourites ? false : uiVisibilityState.notes,
                    quickNav: quickNavHideMenu && !uiVisibilityState.quickFavourites ? false : uiVisibilityState.quickNav
                });
            }
        };
        _this._ariaLabelHandler = function() {
            var intlID = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", defaultMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", notification = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
            var intl = _this.props.intl;
            var notificationType = defaultMessage !== "Activity Center" ? "notifications" : "unread";
            var description = notification > 0 ? ", ".concat(notification, " ").concat(notificationType) : "";
            return "".concat(intl.formatMessage({
                id: intlID,
                defaultMessage: defaultMessage
            })).concat(description);
        };
        _this._onSocialSpheresLoaded = function() {
            _this.setState({
                spheresLoaded: true,
                newConversations: getUnreadCount()
            });
        };
        _this._onNotesChange = function() {
            _this.setState({
                noteCount: getNoteCount()
            });
        };
        _this._onTopicsChange = function() {
            _this.setState({
                newConversations: getUnreadCount()
            });
        };
        _this._onToggleQickChartNav = function() {
            var _this_props = _this.props, uiVisibilityState = _this_props.uiVisibilityState, setUIVisibilityState = _this_props.setUIVisibilityState, navDisabled = _this_props.navDisabled, notify = _this_props.notify;
            Tracker.trackEvent("ActionMenuClick", "ChartQuickNav", "Toggle");
            if (navDisabled) {
                notify("action_not_allowed_while_exam");
            } else {
                setUIVisibilityState({
                    menu: false,
                    quickNav: !uiVisibilityState.quickNav
                });
            }
        };
        _this.state = {
            spheresLoaded: false,
            noteCount: getNoteCount(),
            newConversations: getUnreadCount()
        };
        _this._onStoryModeToggle = _this._onStoryModeToggle.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = AppFooter.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        eventBus.register("c", "app", this._onFavouritesToggle);
        eventBus.register("b", "app", function() {
            return canKeyInput() && _this._onStoryModeToggle();
        });
        eventBus.register("u", "app", this._onBonusMaterialToggle);
        eventBus.register("i", "app", this._onNotesToggle);
        eventBus.register("o", "app", this._onActivityCenterToggle);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _this_props = this.props, isLoadingGroups = _this_props.isLoadingGroups, topics = _this_props.topics, notes = _this_props.notes;
        if (prevProps.isLoadingGroups && !isLoadingGroups) {
            this._onSocialSpheresLoaded();
        }
        if (!isEqual(prevProps.topics, topics)) {
            this._onTopicsChange();
        }
        if (!isEqual(prevProps.notes, notes)) {
            this._onNotesChange();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        eventBus.unregister("c", "app");
        eventBus.unregister("b", "app");
        eventBus.unregister("u", "app");
        eventBus.unregister("i", "app");
        eventBus.unregister("o", "app");
    };
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, navDisabled = _this_props.navDisabled, trackableMaxCharts = _this_props.trackableMaxCharts, trackableVisitedChartsCount = _this_props.trackableVisitedChartsCount, currentChartIndex = _this_props.currentChartIndex, maxCharts = _this_props.maxCharts, storyMode = _this_props.storyMode, setStoryMode = _this_props.setStoryMode, bmCount = _this_props.bmCount, intl = _this_props.intl, quickNav = _this_props.quickNav, engagementServerEnabled = _this_props.engagementServerEnabled;
        var labelClassesBM = classNames("switch-label", {
            "switch-label--active": storyMode
        });
        var labelClassesSM = classNames("switch-label", {
            "switch-label--active": !storyMode
        });
        var toggleStatus = labelClassesBM === "switch-label" ? "Book mode" : "Story mode";
        return /*#__PURE__*/ React.createElement("footer", {
            id: "footer",
            tabIndex: 0,
            className: "app-footer",
            "aria-label": intl.formatMessage({
                id: "ui.footer",
                defaultMessage: "Footer"
            })
        }, /*#__PURE__*/ React.createElement(ProgressDisplay, {
            maxVal: trackableMaxCharts,
            val: trackableVisitedChartsCount,
            compact: true,
            onActivate: this._onToggleQickChartNav
        }), /*#__PURE__*/ React.createElement(PageDisplay, {
            uiVisibilityState: this.props.uiVisibilityState,
            currentChartIndex: currentChartIndex + 1,
            maxCharts: maxCharts,
            disabled: navDisabled,
            onToggleQuickChartNav: this._onToggleQickChartNav
        }), /*#__PURE__*/ React.createElement("div", {
            className: "app-footer__options"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "sr-only",
            id: "cbook_toggle"
        }, toggleStatus), /*#__PURE__*/ React.createElement("span", {
            className: labelClassesBM
        }, intl.formatMessage({
            id: "ui.book_mode",
            defaultMessage: "BOOK-MODE"
        })), /*#__PURE__*/ React.createElement(UISwitch, {
            ariaLabelledby: "cbook_toggle",
            disabled: navDisabled,
            onSwitch: function() {
                return _this._onStoryModeToggle();
            },
            isOn: storyMode
        }), /*#__PURE__*/ React.createElement("span", {
            className: labelClassesSM
        }, intl.formatMessage({
            id: "ui.story_mode",
            defaultMessage: "STORY-MODE"
        }))), /*#__PURE__*/ React.createElement("ul", {
            className: "app-footer__nav actions-menu",
            role: "menu"
        }, quickNav && /*#__PURE__*/ React.createElement("li", {
            id: "quick-favourites",
            className: "actions-menu__item actions-menu__item--quick-favourites",
            role: "menuitem"
        }, /*#__PURE__*/ React.createElement("button", {
            "aria-label": this._ariaLabelHandler("quick_favourites.title", "Favourites"),
            disabled: navDisabled,
            className: "actions-menu__link favourites-link",
            onClick: this._onFavouritesToggle
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "star-fill",
            size: "m"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "actions-menu__link-text"
        }, intl.formatMessage({
            id: "quick_favourites.title",
            defaultMessage: "Favourites"
        })))), /*#__PURE__*/ React.createElement("li", {
            id: "bonus-material",
            className: "actions-menu__item actions-menu__item--bonus-material",
            role: "menuitem"
        }, /*#__PURE__*/ React.createElement("button", {
            "aria-label": this._ariaLabelHandler("bonus_material.title", "Bonus Material", bmCount),
            className: "actions-menu__link bonus-link",
            onClick: this._onBonusMaterialToggle
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "bonus-material",
            size: "m"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "actions-menu__link-text"
        }, intl.formatMessage({
            id: "bonus_material.title",
            defaultMessage: "Bonus Material"
        }))), bmCount > 0 && /*#__PURE__*/ React.createElement("span", {
            className: "numeral-indicator actions-menu__indicator actions-menu__indicator--local",
            "aria-hidden": "true"
        }, bmCount)), /*#__PURE__*/ React.createElement("li", {
            id: "notes",
            className: "actions-menu__item actions-menu__item--notes",
            role: "menuitem"
        }, engagementServerEnabled ? /*#__PURE__*/ React.createElement("button", {
            "aria-label": this._ariaLabelHandler("social.notes.title", "Notes", this.state.noteCount),
            className: "actions-menu__link notes-link",
            onClick: this._onNotesToggle
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "notes",
            size: "m"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "actions-menu__link-text"
        }, intl.formatMessage({
            id: "social.notes.title",
            defaultMessage: "Notes"
        }))) : null, this.state.noteCount ? /*#__PURE__*/ React.createElement("span", {
            className: " numeral-indicator actions-menu__indicator actions-menu__indicator--local",
            "aria-hidden": "true"
        }, this.state.noteCount) : null), /*#__PURE__*/ React.createElement("li", {
            id: "activity-center",
            className: "actions-menu__item actions-menu__item--activity-center",
            role: "menuitem"
        }, engagementServerEnabled ? /*#__PURE__*/ React.createElement("button", {
            "aria-label": this._ariaLabelHandler("ui.activity_center", "Activity Center", this.state.newConversations),
            className: "actions-menu__link activity-link",
            onClick: this._onActivityCenterToggle
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "activity-center",
            size: "m"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "actions-menu__link-text"
        }, intl.formatMessage({
            id: "ui.activity_center",
            defaultMessage: "Activity Center"
        }))) : null, engagementServerEnabled && this.state.newConversations ? /*#__PURE__*/ React.createElement("span", {
            className: "numeral-indicator actions-menu__indicator",
            "aria-hidden": "true"
        }, this.state.newConversations) : null)));
    };
    return AppFooter;
}(PureComponent);
export var Component = AppFooter;
export default injectIntl(AppFooter);
